import { apiFetch } from "./apiClient";
import type { AccessRequest, AuthMe } from "../types/api";

export function getAuthMe(): Promise<AuthMe> {
  return apiFetch<AuthMe>("/api/v1/admin/auth/me");
}

export function logout(): Promise<{ signedOut: boolean }> {
  return apiFetch<{ signedOut: boolean }>("/api/v1/admin/auth/logout", { method: "POST" });
}

export function listAccessRequests(): Promise<AccessRequest[]> {
  return apiFetch<AccessRequest[]>("/api/v1/admin/access-requests");
}

export function approveAccessRequest(id: number): Promise<AccessRequest> {
  return apiFetch<AccessRequest>(`/api/v1/admin/access-requests/${id}/approve`, { method: "POST" });
}

export function rejectAccessRequest(id: number): Promise<AccessRequest> {
  return apiFetch<AccessRequest>(`/api/v1/admin/access-requests/${id}/reject`, { method: "POST" });
}

export function entraLoginUrl(): string {
  const configured = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  const base = configured ? (configured.endsWith("/") ? configured.slice(0, -1) : configured) : "";
  return `${base}/api/v1/admin/auth/login`;
}
